<template>
    <InformeCard title="Total de recaudación">
        <b-row>
            <b-col cols="12">
                <div class="info-box" id="total-parcelas">
                    <span class="info-box-icon bg-info"><i class="fas fa-ticket-alt"></i></span>
    
                    <div class="info-box-content">
                        <span class="info-box-text">TOTAL PARCELAS:</span>
                        <span class="info-box-number">{{ estadisticas.total_parcelas }}</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="info-box" id="total-recaudacion">
                    <span class="info-box-icon bg-info"><i class="far fa-money-bill-alt"></i></span>
    
                    <div class="info-box-content">
                        <span class="info-box-text">TOTAL RECAUDACIÓN (€):</span>
                        <span class="info-box-number">{{ estadisticas.total_price | formatear_precio }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>
    </InformeCard>
</template>

<script>
    import InformeCard from '@/components/backend/estadisticas/InformeCard';

    export default {
        name: "TotalRecaudacion",
        props: {
            estadisticas: {
                type: Object,
                required: true
            }
        },
        components: {
            InformeCard
        }
    }
</script>